module.exports = __webpack_public_path__ + "static/media/attachment-inactive.dd5a9c72.svg";